module.exports = __webpack_public_path__ + "static/media/character.cce51623.png";